function Outlook(props: any) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1270_497)">
    <path d="M6.25195 6.25195H12V12H6.25195V6.25195Z" fill="#F5B200"/>
    <path d="M6.25195 0H12V5.748H6.25195V0Z" fill="#62BC2B"/>
    <path d="M0 6.25195H5.748V12H0V6.25195Z" fill="#219ADA"/>
    <path d="M0 0H5.748V5.748H0V0Z" fill="#F32601"/>
    </g>
    <defs>
    <clipPath id="clip0_1270_497">
    <rect width="12" height="12" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  );
}

export default Outlook;
